import { useNamespacedStore } from '~/compositions/store'

import { watch, computed } from '~/utils/nuxt3-migration'
import {
  LOGIN_MODAL_NS,
  LoginModalState
} from '~/store/modules/shared/login-modal/state'
import {
  SET_LOGIN_MODAL_VISIBILITY,
  REDIRECT_AFTER_LOGIN,
  SET_DEALER_MODE
} from '~/store/modules/shared/login-modal/mutation-types'
export function useLoginModal(params?: {
  onSuccess?: Function
  onShow?: Function
  onHide?: Function
  redirectAfterLogin?: boolean
  dealerMode?: boolean
}) {
  const { state, commit } = useNamespacedStore<LoginModalState>(LOGIN_MODAL_NS)

  const { onSuccess, redirectAfterLogin, dealerMode, onShow, onHide } =
    params || {}

  if (typeof redirectAfterLogin === 'boolean') {
    commit(REDIRECT_AFTER_LOGIN, redirectAfterLogin)
  }
  if (typeof dealerMode === 'boolean') {
    commit(SET_DEALER_MODE, dealerMode)
  }

  // Local flag to track if this instance initiated login
  let isThisInstanceActive = false

  function showModal() {
    isThisInstanceActive = true
    commit(SET_LOGIN_MODAL_VISIBILITY, true)
  }

  function hideModal() {
    isThisInstanceActive = false
    commit(SET_LOGIN_MODAL_VISIBILITY, false)
  }

  const isLoginSuccess = computed(() => state.isLoginSuccess)
  const isLoginModalVisible = computed(() => state.isLoginModalVisible)

  watch(isLoginSuccess, val => {
    if (val && isThisInstanceActive && onSuccess) {
      onSuccess()
      // Optionally reset the flag after success
      isThisInstanceActive = false
    }
  })

  watch(isLoginModalVisible, (val, oldVal) => {
    if (!isThisInstanceActive) {
      return
    }
    if (val && !oldVal) {
      onShow && onShow()
    } else if (oldVal && !val) {
      onHide && onHide()
      // Reset the instance active flag when modal closes
      isThisInstanceActive = false
    }
  })

  return {
    hideModal,
    showModal
  }
}
